import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../config/httpConfig";

export const markTransactionDuplicate = createAsyncThunk(
  "payments/markTransactionDuplicate",
  async ({ transactionId, originalTransactionId }, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/markTransactionDuplicate", {
        transactionId,
        originalTransactionId: originalTransactionId || undefined,
      });
      return response.response;
    } catch (error) {
      return rejectWithValue(error?.message || "Failed to mark transaction as duplicate");
    }
  }
);

export const transactionHistory = createAsyncThunk(
  "payments/transactionHistory",
  async ({ page = 1, pageSize = 10 }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/admin/transactionHistory?page=${page}&limit=${pageSize}`
      );
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const disputeRaised = createAsyncThunk(
  "payments/disputeRaised",
  async ({ page = 1, pageSize = 10 }) => {
    const response = await axios.get(
      `/api/admin/disputeRaised?page=${page}&limit=${pageSize}`
    );
    return response.response;
  }
);

export const rejectTxn = createAsyncThunk(
  "payments/rejectTxn",
  async ({ page = 1, pageSize = 10 }) => {
    const response = await axios.get(
      `/api/admin/rejectTxn?page=${page}&limit=${pageSize}`
    );
    return response.response;
  }
);

export const pendingTxn = createAsyncThunk(
  "payments/pendingTxn",
  async ({ page = 1, pageSize = 10 }) => {
    const response = await axios.get(
      `/api/admin/pendingTxn?page=${page}&limit=${pageSize}`
    );
    return response.response;
  }
);

export const suspenseTxn = createAsyncThunk(
  "payments/suspenseTxn",
  async ({ page = 1, pageSize = 10, isLoad = false }) => {
    const response = await axios.get(
      isLoad
        ? `/api/admin/fetchAndInsertSuspiciousTransactions?page=${page}&limit=${pageSize}`
        : `/api/admin/getSuspiciousTransactions?page=${page}&limit=${pageSize}`
    );

    return response.response;
  }
);

export const getReferenceTxn = createAsyncThunk(
  "payments/getReferenceTxn",
  async (transactionId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/admin/getReferenceTxn?refTransactionId=${transactionId}`
      );
      return response.response;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getTxnDetails = createAsyncThunk(
  "payments/getTxnDetails",
  async (transactionId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/admin/getTxnDetails?transactionId=${transactionId}`
      );
      return response.response;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const addDispute = createAsyncThunk(
  "payments/addDispute",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/addDispute", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const getAllDisputeType = createAsyncThunk(
  "payments/getAllDisputeType",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("/api/admin/getAllDisputeType");
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDisputeRaisedFor = createAsyncThunk(
  "payments/getDisputeRaisedFor",
  async (transactionId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/admin/getDisputeRaisedFor?transactionId=${transactionId}`
      );
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getAllDisputePriority = createAsyncThunk(
  "payments/getAllDisputePriority",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("/api/admin/getAllDisputePriority");
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getAllDisputeReasonById = createAsyncThunk(
  "payments/getAllDisputeReasonById",
  async (disputeTypeId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/admin/getAllDisputeReasonById?disputeTypeId=${disputeTypeId}`
      );
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDisputeById = createAsyncThunk(
  "payments/getDisputeById",
  async (disputeId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/admin/getDisputeDetailsById?disputeId=${disputeId}`
      );
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getEscalationById = createAsyncThunk(
  "payments/getEscalationById",
  async (escalationId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/admin/getEscalationById?escalationId=${escalationId}`
      );
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addResolution = createAsyncThunk(
  "payments/addResolution",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/addResolution", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occured");
    }
  }
);

export const getAllResolutionType = createAsyncThunk(
  "payments/getAllResolutionType",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("/api/admin/getAllResolutionType");
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getAllResolutionReasonById = createAsyncThunk(
  "payments/getAllResolutionReasonById",
  async (resolutionTypeId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/admin/getAllResolutionReasonById?resolutionTypeId=${resolutionTypeId}`
      );
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addEscalation = createAsyncThunk(
  "payments/addEscalation",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/addEscalation", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occured");
    }
  }
);

export const addEscalationCommentsById = createAsyncThunk(
  "payments/addEscalationCommentsById",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/api/admin/addEscalationCommentsById",
        payload
      );
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occured");
    }
  }
);

export const PaymentSlice = createSlice({
  name: "payments",
  initialState: {
    loading: false,
    error: "",
    txnHistoryData: [],
    rejectedDisputeData: [],
    pendingApprovalData: [],
    suspenseData: {},
    refTxnLoading: false,
    refTxnData: [],
    txnData: {},
    reasonSubmitError: "",
    reasonSubmitLoading: false,
    disputeSubmitLoading: false,
    disputeTypes: [],
    disputeUsers: [],
    disputePriority: [],
    disputeReason: [],
    disputeDetails: {},
    escalationDetails: {},
    escalationSubmitLoading: false,
    resolveSubmitLoading: false,
    resolutionType: [],
    resolutionReason: [],
    escalationLoading: false,
    disputeLoading: false,
  },

  extraReducers: (builder) => {
    builder.addCase(transactionHistory.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(transactionHistory.fulfilled, (state, action) => {
      state.loading = false;
      state.txnHistoryData = action.payload;
      state.error = "";
    });
    builder.addCase(transactionHistory.rejected, (state, action) => {
      state.loading = false;
      state.txnHistoryData = [];
      state.error = action.payload;
    });

    builder.addCase(disputeRaised.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(disputeRaised.fulfilled, (state, action) => {
      state.loading = false;
      state.rejectedDisputeData = action.payload;
    });
    builder.addCase(disputeRaised.rejected, (state, action) => {
      state.loading = false;
      state.rejectedDisputeData = [];
      state.error = action.payload;
    });

    builder.addCase(rejectTxn.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(rejectTxn.fulfilled, (state, action) => {
      state.loading = false;
      state.rejectedDisputeData = action.payload;
    });
    builder.addCase(rejectTxn.rejected, (state, action) => {
      state.loading = false;
      state.rejectedDisputeData = [];
      state.error = action.payload;
    });

    builder.addCase(pendingTxn.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(pendingTxn.fulfilled, (state, action) => {
      state.loading = false;
      state.pendingApprovalData = action.payload;
    });
    builder.addCase(pendingTxn.rejected, (state, action) => {
      state.loading = false;
      state.pendingApprovalData = [];
      state.error = action.payload;
    });

    builder.addCase(suspenseTxn.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(suspenseTxn.fulfilled, (state, action) => {
      state.loading = false;

      state.suspenseData = action.payload;
    });
    builder.addCase(suspenseTxn.rejected, (state, action) => {
      state.loading = false;
      state.suspenseData = {};
      state.error = action.payload;
    });

    builder.addCase(getReferenceTxn.pending, (state) => {
      state.refTxnLoading = true;
      state.error = "";
    });
    builder.addCase(getReferenceTxn.fulfilled, (state, action) => {
      state.refTxnLoading = false;
      state.refTxnData = action.payload;
      state.error = "";
    });
    builder.addCase(getReferenceTxn.rejected, (state, action) => {
      state.refTxnLoading = false;
      state.refTxnData = [];
      state.error = action.payload;
    });

    builder.addCase(getTxnDetails.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getTxnDetails.fulfilled, (state, action) => {
      state.loading = false;
      state.txnData = action.payload;
    });
    builder.addCase(getTxnDetails.rejected, (state, action) => {
      state.loading = false;
      state.txnData = {};
      state.error = action.payload;
    });

    builder.addCase(addDispute.pending, (state) => {
      state.disputeSubmitLoading = true;
      state.error = "";
    });
    builder.addCase(addDispute.fulfilled, (state, action) => {
      state.disputeSubmitLoading = false;
      state.error = "";
    });
    builder.addCase(addDispute.rejected, (state, action) => {
      state.disputeSubmitLoading = false;
      state.error = action.payload;
    });

    builder.addCase(addEscalation.pending, (state) => {
      state.escalationSubmitLoading = true;
      state.error = "";
    });
    builder.addCase(addEscalation.fulfilled, (state, action) => {
      state.escalationSubmitLoading = false;
      state.error = "";
    });
    builder.addCase(addEscalation.rejected, (state, action) => {
      state.escalationSubmitLoading = false;
      state.error = action.payload;
    });

    builder.addCase(addEscalationCommentsById.pending, (state) => {
      state.escalationSubmitLoading = true;
      state.error = "";
    });
    builder.addCase(addEscalationCommentsById.fulfilled, (state, action) => {
      state.escalationSubmitLoading = false;
      state.error = "";
    });
    builder.addCase(addEscalationCommentsById.rejected, (state, action) => {
      state.escalationSubmitLoading = false;
      state.error = action.payload;
    });

    builder.addCase(getAllDisputeType.fulfilled, (state, action) => {
      state.disputeTypes = action.payload;
    });

    builder.addCase(getDisputeRaisedFor.fulfilled, (state, action) => {
      state.disputeUsers = action.payload;
    });

    builder.addCase(getAllDisputePriority.fulfilled, (state, action) => {
      state.disputePriority = action.payload;
    });
    builder.addCase(getAllDisputeReasonById.fulfilled, (state, action) => {
      state.disputeReason = action.payload;
    });

    builder.addCase(getDisputeById.pending, (state) => {
      state.disputeLoading = true;
      state.error = "";
    });
    builder.addCase(getDisputeById.fulfilled, (state, action) => {
      state.disputeLoading = false;
      state.disputeDetails = action.payload;
    });
    builder.addCase(getDisputeById.rejected, (state, action) => {
      state.disputeLoading = false;
      state.disputeDetails = {};
      state.error = action.payload;
    });

    builder.addCase(getEscalationById.pending, (state) => {
      state.escalationLoading = true;
      state.error = "";
    });
    builder.addCase(getEscalationById.fulfilled, (state, action) => {
      state.escalationLoading = false;
      state.escalationDetails = action.payload;
    });
    builder.addCase(getEscalationById.rejected, (state, action) => {
      state.escalationLoading = false;
      state.escalationDetails = [];
      state.error = action.payload;
    });

    builder.addCase(getAllResolutionType.fulfilled, (state, action) => {
      state.resolutionType = action.payload;
    });
    builder.addCase(getAllResolutionReasonById.fulfilled, (state, action) => {
      state.resolutionReason = action.payload;
    });

    builder.addCase(addResolution.pending, (state) => {
      state.resolveSubmitLoading = true;
      state.error = "";
    });
    builder.addCase(addResolution.fulfilled, (state, action) => {
      state.resolveSubmitLoading = false;
      state.error = "";
    });
    builder.addCase(addResolution.rejected, (state, action) => {
      state.resolveSubmitLoading = false;
      state.error = action.payload;
    });
  },

  reducers: {
    updatePaymentErrState(state) {
      state.error = "";
    },
  },
});

export const { updatePaymentErrState } = PaymentSlice.actions;

export default PaymentSlice.reducer;
